import React, { createContext, useContext, useState, useCallback } from 'react';
import { getUser, getToken, setAuth, clearAuth } from '../utils/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(getUser);
  const [token, setToken] = useState(getToken);

  const login = useCallback((tkn, usr) => {
    setAuth(tkn, usr);
    setToken(tkn);
    setUser(usr);
  }, []);

  const logout = useCallback(() => {
    clearAuth();
    setToken(null);
    setUser(null);
  }, []);

  return (
    <AuthContext.Provider value={{ user, token, login, logout, isLoggedIn: !!token, role: user?.role }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
